// extracted by mini-css-extract-plugin
module.exports = {"container":"_25i-pSBbOlBebs72AFdPnQ"};